{
    "locale": "de",
    "nationalities": {
        "AF": "Afghanisch",
        "AL": "Albanisch",
        "DZ": "Algerisch",
        "AD": "Andorranisch",
        "AO": "Angolanisch",
        "AG": "Antiguanisch",
        "AR": "Argentinisch",
        "AM": "Armenisch",
        "AU": "Australisch",
        "AT": "Österreichisch",
        "AZ": "Aserbaidschanisch",
        "BS": "Bahamaisch",
        "BH": "Bahrainisch",
        "BD": "Bangladeschisch",
        "BB": "Barbadisch",
        "BY": "Weißrussisch",
        "BE": "Belgisch",
        "BZ": "Belizisch",
        "BJ": "Beninisch",
        "BM": "Bermudisch",
        "BT": "Bhutanisch",
        "BO": "Bolivisch",
        "BA": "Bosnisch",
        "BW": "Botsuanisch",
        "BV": "Bouvet insel",
        "BR": "Brasilianisch",
        "IO": "Britisches Territorium im Indischen Ozean",
        "BN": "Bruneiisch",
        "BG": "Bulgarisch",
        "BF": "Burkinisch",
        "BI": "Burundisch",
        "KH": "Kambodschanisch",
        "CM": "Kamerunisch",
        "CA": "Kanadisch",
        "CV": "Kapverdisch",
        "KY": "Kaimaninseln",
        "CF": "Zentralafrikanisch",
        "TD": "Tschadisch",
        "CL": "Chilenisch",
        "CN": "Chinesisch",
        "CX": "Weihnachtsinsel",
        "CC": "Kokosinseln",
        "CO": "Kolumbisch",
        "KM": "Komorisch",
        "CG": "Kongolesisch (Republik Kongo)",
        "CD": "Kongolesisch (Demokratische Republik Kongo)",
        "CK": "Cookinseln",
        "CR": "Costa-Ricanisch",
        "CI": "Ivorisch",
        "HR": "Kroatisch",
        "CU": "Kubanisch",
        "CY": "Zyprisch",
        "CZ": "Tschechisch",
        "DK": "Dänisch",
        "DJ": "Dschibutisch",
        "DM": "Dominicanisch",
        "DO": "Dominikanisch",
        "EC": "Ecuadorianisch",
        "EG": "Ägyptisch",
        "SV": "Salvadorianisch",
        "GQ": "Äquatorial-Guineisch",
        "ER": "Eritreisch",
        "EE": "Estnisch",
        "ET": "Äthiopisch",
        "FK": "Falklandinseln",
        "FO": "Färöer",
        "FJ": "Fidschianisch",
        "FI": "Finnisch",
        "FR": "Französisch",
        "GF": "Französisch-Guayana",
        "PF": "Französisch-Polynesien",
        "TF": "Französische Süd- und Antarktisgebiete",
        "GA": "Gabunisch",
        "GM": "Gambisch",
        "GE": "Georgisch",
        "DE": "Deutsch",
        "GH": "Ghanaisch",
        "GI": "Gibraltar",
        "GR": "Griechisch",
        "GL": "Grönländisch",
        "GD": "Grenadisch",
        "GP": "Guadeloupe",
        "GU": "Guamisch",
        "GT": "Guatemaltekisch",
        "GN": "Äquatorial-Guineisch",
        "GW": "Guinea-Bissauisch",
        "GY": "Guyanisch",
        "HT": "Haitianisch",
        "HM": "Heard und McDonaldinseln",
        "VA": "Vatikanisch",
        "HN": "Honduranisch",
        "HK": "Hongkong",
        "HU": "Ungarisch",
        "IS": "Isländisch",
        "IN": "Indisch",
        "ID": "Indonesisch",
        "IR": "Iranisch",
        "IQ": "Irakisch",
        "IE": "Irisch",
        "IL": "Israelisch",
        "IT": "Italienisch",
        "JM": "Jamaikanisch",
        "JP": "Japanisch",
        "JO": "Jordanisch",
        "KZ": "Kasachisch",
        "KE": "Kenianisch",
        "KI": "Kiribatisch",
        "KP": "Nordkoreanisch",
        "KR": "Südkoreanisch",
        "KW": "Kuwaitisch",
        "KG": "Kirgisisch",
        "LA": "Laotisch",
        "LV": "Lettisch",
        "LB": "Libanesisch",
        "LS": "Lesothisch",
        "LR": "Liberianisch",
        "LY": "Libysch",
        "LI": "Liechtensteinisch",
        "LT": "Litauisch",
        "LU": "Luxemburgisch",
        "MO": "Macau",
        "MG": "Madagassisch",
        "MW": "Malawisch",
        "MY": "Malaysisch",
        "MV": "Maledivisch",
        "ML": "Malisch",
        "MT": "Maltesisch",
        "MH": "Marshallisch",
        "MQ": "Martinique",
        "MR": "Mauretanisch",
        "MU": "Mauritisch",
        "YT": "Mayotte",
        "MX": "Mexikanisch",
        "FM": "Mikronesisch",
        "MD": "Moldawisch",
        "MC": "Monegassisch",
        "MN": "Mongolisch",
        "MS": "Montserrat",
        "MA": "Marokkanisch",
        "MZ": "Mosambikanisch",
        "MM": "Myanmarisch",
        "NA": "Namibisch",
        "NR": "Nauruisch",
        "NP": "Nepalesisch",
        "NL": "Niederländisch",
        "NC": "Neukaledonien",
        "NZ": "Neuseelandneuseeländisch",
        "NI": "Nicaraguanisch",
        "NE": "Nigerianisch",
        "NG": "Nigerianisch",
        "NU": "Niueanisch",
        "NF": "Norfolkinsel",
        "MK": "Mazedonisch",
        "MP": "Nördliche Marianen",
        "NO": "Norwegisch",
        "OM": "Omanisch",
        "PK": "Pakistanisch",
        "PW": "Palauisch",
        "PS": "Gazastreifen",
        "PA": "Panamaisch",
        "PG": "Papua-Neuguienisch",
        "PY": "Paraguayisch",
        "PE": "Peruanisch",
        "PH": "Philippinsch",
        "PN": "Pitcairninseln",
        "PL": "Polnisch",
        "PT": "Portugiesisch",
        "PR": "Puerto-Ricanisch",
        "QA": "Katarisch",
        "RE": "Réunion",
        "RO": "Rumänisch",
        "RU": "Russisch",
        "RW": "Ruandisch",
        "SH": "St.Helena",
        "KN": "St. Kitts und Nevis",
        "LC": "Lucianisch",
        "PM": "St. Pierre und Miquelon",
        "VC": "Vincentisch",
        "WS": "Samoanisch",
        "SM": "San-Marinesisch",
        "ST": "São-Toméisch",
        "SA": "Saudi-Arabisch",
        "SN": "Senegalesisch",
        "SC": "Seychellisch",
        "SL": "Sierra-Leonisch",
        "SG": "Singapurisch",
        "SK": "Slowakisch",
        "SI": "Slowenisch",
        "SB": "Salomonisch",
        "SO": "Somalisch",
        "ZA": "Südafrikanisch",
        "GS": "Südgeorgien und die Südlichen Sandwichinseln",
        "ES": "Spanisch",
        "LK": "Sri-Lankisch",
        "SD": "Sudanesisch",
        "SR": "Surinamisch",
        "SJ": "Jan Mayen",
        "SZ": "Swasiländisch",
        "SE": "Schwedisch",
        "CH": "Schweizerisch",
        "SY": "Syrisch",
        "TW": "Taiwanesisch",
        "TJ": "Tadschikisch",
        "TZ": "Tansanisch",
        "TH": "Thailändisch",
        "TL": "Timoresisch",
        "TG": "Togolesisch",
        "TK": "Tokelau",
        "TO": "Tongaisch",
        "TT": "Trinidad und Tobago",
        "TN": "Tunesisch",
        "TR": "Türkisch",
        "TM": "Turkmenisch",
        "TC": "Turks- und Caicosinseln",
        "TV": "Tuvaluisch",
        "UG": "Ugandisch",
        "UA": "Ukrainisch",
        "AE": "Vereinigte Arabische Emirate",
        "GB": "Britisch",
        "US": "Amerikanisch",
        "UM": "United States Minor Outlying Islands",
        "UY": "Uruguayisch",
        "UZ": "Usbekisch",
        "VU": "Vanuatisch",
        "VE": "Venezolanisch",
        "VN": "Vietnamesisch",
        "VG": "Britische Jungferninseln",
        "VI": "Amerikanische Jungferninseln",
        "WF": "Wallis und Futuna",
        "EH": "Westsahara",
        "YE": "Jemenitisch",
        "ZM": "Sambisch",
        "ZW": "Simbabwisch",
        "AX": "Åland Insel",
        "BQ": "Bonaire, Sint Eustatius und Saba",
        "CW": "Curaçao",
        "GG": "Guernsey",
        "IM": "Man (Isle of Man)",
        "JE": "Jersey",
        "ME": "Montenegrinisch",
        "BL": "St. Barthélemy",
        "MF": "Saint-Martin",
        "RS": "Serbisch",
        "SX": "Sint Maarten",
        "SS": "Südsudanesisch",
        "XK": "Kosovo"
    }
}